import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { StatusCollection } from '../index'

export const setupStatusReplication = (
  collection: StatusCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'statuses',
    displayName: 'Status',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      // Backend sends ProjectIds (Guid[]). Coerce defensively in case an older
      // server build still sends the legacy single ProjectId field.
      projectIds: Array.isArray(doc.projectIds)
        ? doc.projectIds
        : doc.projectId
        ? [doc.projectId]
        : [],
      name: doc.name,
      progressType: doc.progressType || 'BL',
      description: doc.description || '',
      sortOrder: String(doc.sortOrder),
      isSystemGenerated: doc.isSystemGenerated || false,
      isDefault: doc.isDefault || false,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      projectIds: state.projectIds ?? [],
      name: state.name,
      progressType: state.progressType,
      description: state.description,
      sortOrder: state.sortOrder,
      isSystemGenerated: state.isSystemGenerated,
      isDefault: state.isDefault,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
